module.exports = __webpack_public_path__ + "static/media/dark-check-icon.be98d045.svg";